import type { ServerResponse } from '@core/utils';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Image } from '@/components/client';

export const useToastPoint = () => {
  const queryClient = useQueryClient();

  const toastPoint = (point: number) => {
    toast(
      () => (
        <>
          <div className="pointer-events-auto flex min-h-48 items-center gap-8 rounded-pill bg-Gray-black/70 px-20 font-400 text-Gray-white">
            <Image
              alt="동전"
              height={30}
              src="/assets/pngs/coin2.png"
              width={30}
            />
            <p className="font-400 typo-body4">
              <span className="font-700 text-[#C49B5F]">
                {Math.abs(point).toLocaleString()}P
              </span>
              {point >= 0 ? '가 적립됐어요!' : '가 차감됐어요!'}
            </p>
          </div>
        </>
      ),
      {
        className:
          '!bg-transparent !p-0 !shadow-none pointer-events-none justify-center',
      },
    );

    //* 포인트 정보 갱신
    queryClient.invalidateQueries();
  };

  const toastPointError = ({ error }: { error: unknown }) => {
    const { return_code: errorCode, return_message: errorMessage } =
      error as ServerResponse;

    const toastErrorMessage = (message: string) =>
      toast(
        () => (
          <>
            <div className="pointer-events-auto flex min-h-48 items-center gap-8 rounded-pill bg-Gray-black/70 px-20 font-400 text-Gray-white">
              <Image
                alt="동전"
                height={30}
                src="/assets/pngs/coin2.png"
                width={30}
              />
              <p className="font-400 typo-body4">{message}</p>
            </div>
          </>
        ),
        {
          className:
            '!bg-transparent !p-0 !shadow-none pointer-events-none justify-center',
        },
      );

    if (!errorCode || !errorMessage) {
      return toastErrorMessage('서버로 부터 정상적인 응답을 받지 못했습니다.');
    }

    if (30000 <= errorCode) {
      return toastErrorMessage(errorMessage);
    }

    return toastErrorMessage(
      `일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요. (${errorCode})`,
    );
  };

  return {
    toastPoint,
    toastPointError,
  };
};
